import React, { Fragment, useContext, useState } from "react";
/// React router dom
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";

export function  NavMenuToggle(){
	setTimeout(()=>{	
		let mainwrapper = document.querySelector("#main-wrapper");
		if(mainwrapper.classList.contains('menu-toggle')){
			mainwrapper.classList.remove("menu-toggle");
		}else{
			mainwrapper.classList.add("menu-toggle");
		}
	},200);
}

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  const { navigationHader, openMenuToggle, background } = useContext(
    ThemeContext
  );
  return (
    <div className="nav-header">
      <a 
        href="/admin/adminDashboard" 
        target="_blank" 
        rel="noopener noreferrer"
        className="brand-logo" 
        style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
      >
        <img 
          src="https://res.cloudinary.com/dihtuaq6d/image/upload/v1760187144/xrk9fhrhbahbkvjzy1db.jpg" 
          alt="SenOffre Logo" 
          style={{ 
            height: '80px', 
            width: 'auto',
            objectFit: 'contain',
            cursor: 'pointer'
          }} 
        />
      </a>

      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
